import React from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import { useMutation } from '../hooks/useMutation';

const SEND_MESSAGE = `
mutation SendMessage($input: MessageInput!) {
    sendMessage(input: $input)
}
`;

const ChatTextBox = (props) => {
  const { size, admin, i18n } = props || {};
  const [text, setText] = React.useState('');
  const [uuid, setUuid] = React.useState('');

  const { mutate } = useMutation(SEND_MESSAGE);

  const onChange = (e) => {
    setText(e.target.value);
  };

  const onClick = async () => {
    const { variables, afterClick } = props;

    const input = {
      ...variables,
      text,
      ...(admin ? { agentUnique: `rentals-${uuid}` } : {})
    };
    await mutate({ input });
    await afterClick();
    setText('');
  };

  return (
    <FormControl fullWidth>
      {admin ? (
        <TextField
          placeholder={i18n('Enter Dwelling ID')}
          style={{ marginBottom: '6px', marginTop: '6px' }}
          onChange={(e) => setUuid(e.target.value)}
          variant="outlined"
          value={uuid}
        />
      ) : null}
      <div style={{ display: 'flex' }}>
        <TextField
          fullWidth
          multiline
          rows={size}
          placeholder={i18n('Enter message')}
          onChange={onChange}
          variant="outlined"
          value={text}
          style={{ marginRight: '6px' }}
        />
        <Button onClick={onClick}>Send</Button>
      </div>
    </FormControl>
  );
};

export default ChatTextBox;